import endpoints from 'api/endpoints';
import { api } from 'api/rest';

export class RegistrationStatisticsService {
  static getDaily(days: number) {
    return api.get(endpoints.registrationStats, { params: { days } });
  }
}
